import axios from "../services/api/api";

export const SetFavoriteCourse = async ({ courseId, isFavorite }) => {
  await axios.put(
    `/student/FavoriteCourse?courseId=${courseId}&isFavorite=${isFavorite}`,
  );
};
